import { render, staticRenderFns } from "./_shared.html?vue&type=template&id=d528ec2e&"
import script from "./Cores.vue?vue&type=script&lang=js&"
export * from "./Cores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports